<template>
  <v-navigation-drawer
    :mini-variant="mini"
    v-model="drawer"
    hide-overlay
    app
    dark
    lazy
    :value="accountAuthorized"
    width="140"
    mobile-breakpoint="960"
  >
    <div id="company-logo" v-if="UISettings.logo"></div>
    <p v-if="UISettings && UISettings.contacts" class="caption mx-3 mt-3 white--text">
      {{ UISettings && UISettings.contacts.name }}
    </p>

    <div class="student-selector white--text mx-3" v-if="usersCount > 1 && isMobile">

      <h2 class="body-1">{{ 'student:' | lang }}</h2>
      <v-radio-group class="student-selector-radio-group" v-model="userId">
        <v-radio
          v-for="user in users"
          :key="user.id"
          :label="user.name"
          :value="user.id"
        ></v-radio>
      </v-radio-group>
      <div class="body-2" v-if="currentUser">
        <p class="ma-1">{{ currentUser.email }} id {{ currentUser.id }}</p>
      </div>
    </div>

    <v-list dense>
      <v-list-item to="/">
        <v-list-item-icon>
          <v-icon>mdi-ballot-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ 'main' | lang }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/calendar" v-if="allowPages.pageLessons">
        <v-list-item-icon>
          <v-icon>mdi-teach</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ 'lessons' | lang }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="joins" v-if="allowPages.pageCourses">
        <v-list-item-icon>
          <v-icon>mdi-cube-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ 'subjects' | lang }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/operations" v-if="allowPages.pagePayments && allowPages.pageSubscriptions">
        <v-list-item-icon>
          <v-icon>mdi-cash-multiple</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ 'payments./subs.' | lang }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/files" v-if="allowPages.pageFiles">
        <v-list-item-icon>
          <v-icon>mdi-file</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ 'files' | lang }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="payments" v-if="allowPages.pagePayments && !allowPages.pageSubscriptions">
        <v-list-item-icon>
          <v-icon>mdi-cash-multiple</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ 'payments' | lang }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="subscriptions"
                   v-if="!allowPages.pagePayments && allowPages.pageSubscriptions">
        <v-list-item-icon>
          <v-icon>mdi-cash-multiple</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ 'subscriptions' | lang }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/contacts" v-if="hasContatcs">
        <v-list-item-icon>
          <v-icon>mdi-domain</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ 'contacts' | lang }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/settings">
        <v-list-item-icon>
          <v-icon>mdi-cog</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ 'settings' | lang }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <div v-if="UISettings && UISettings.contacts" class="mx-3 contacts">
      <div class="caption white--text" v-if="UISettings.contacts.phone">
      {{ UISettings.contacts.phone}}
      </div>
      <div class="caption white--text" v-if="UISettings.contacts.email">
        <a v-bind:href="'mailto:'+UISettings.contacts.email">{{ UISettings.contacts.email }}</a>
      </div>
      <div class="caption white--text" v-if="companySite">
        <a v-bind:href="UISettings.contacts.site" target="_blank">{{ companySite }}</a>
      </div>
    </div>
    <div v-if="UISettings && UISettings.useTerms" class="mx-3 mt-2 contacts">
      <a class="caption white--text text-decoration-underline"
         @click="setUseTermsDialog(true)">
        {{ 'terms of use' | lang }}
      </a>
    </div>
    <template v-slot:append>
      <v-list dense>
        <v-list-item @click="logout" v-bind:style="{marginBottom: isMobile ? '10px' : '0'}">
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ 'exit' | lang }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <div v-if="allowOnlinePayment" class="mx-3 contacts">
        <img src="../assets/payment_systems.png">
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Account from '../api/Account';
import { destroyJivoSiteWidget } from '@/lib/jivoSiteWidgetHelpers';

export default {
  name: 'MainMenu',
  data: () => ({
    mini: false,
  }),
  computed: {
    hasContatcs() {
      return this.UISettings && this.UISettings.contacts && this.UISettings.contacts.full;
    },
    allowPages() {
      return this.UISettings.allowPages || {};
    },
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    drawer: {
      get() {
        return this.$store.state.drawerShow && this.accountAuthorized;
      },
      set(value) {
        return this.$store.commit('setDrawerState', value);
      },
    },
    companySite() {
      if (this.UISettings && this.UISettings.contacts && this.UISettings.contacts.site) {
        const matches = this.UISettings.contacts.site.match(/^https?:\/\/([^/?#]+)(?:[/?#]|$)/i);
        return matches && matches[1];
      }
      return false;
    },
    userId: {
      get() {
        const user = this.$store.getters.currentUser;
        return user ? user.id : null;
      },
      set(value) {
        this.$store.commit('setCurrentUserId', value);
      },
    },
    ...mapGetters(['accountAuthorized', 'UISettings', 'allowOnlinePayment', 'jivoSiteWidgetUrl', 'currentUser', 'usersCount', 'users']),
  },
  methods: {
    showDrawer() {
      this.$store.commit('setDrawerState', true);
    },
    async logout() {
      if (this.jivoSiteWidgetUrl && this.currentUser) {
        destroyJivoSiteWidget({
          currentUser: this.currentUser,
          widgetUrl: this.jivoSiteWidgetUrl,
        });
      }
      await Account.logout();
      await this.$router.push('/auth/login');
      this.$store.commit('setAccountData', {});
    },
    ...mapMutations(['setUseTermsDialog']),
  },
};
</script>

<style scoped lang="less">
  .v-list-item--active {
    color: #ffffff;
  }

  .v-list-item {
    padding: 0 10px;
  }

  .v-list-item__icon {
    margin-right: 8px !important;
  }

  #company-logo {
    display: block;
    height: 120px;
    margin: 10px;
    background-size: contain;
    background-position: center;
  }

  .contacts {
    line-height: 1;
    div {
      overflow: hidden;
      text-overflow: ellipsis;
    }
   a {
    color: #ffffff;
    }
  }
</style>

<style lang="less">
  .student-selector {
    display: none;
    margin-bottom: 20px;

    .student-selector-radio-group {
      margin-left: -6px;
      .v-radio {
        .v-input--selection-controls__input {
          margin-right: 4px;
        }
      }
      .v-input--selection-controls__input {
        width: 25px;
      }
    }

    div {
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .v-input--selection-controls {
      margin-top: 0px;
    }

    .v-messages {
      display: none;
    }

    label.v-label.theme--dark {
      color: #ffffff;
      font-size: 0.8525rem;
    }

    .v-icon {
      font-size: 18px;
    }

    .body-2 {
      font-weight: 300;
    }
  }

  @media (max-width: 353px) {
    .student-selector {
      display: block;
    }

    .user-info {
      display: none;
    }
  }
</style>
